// ==============================|| OVERRIDES - TAB ||============================== //

export default function Tab (theme) {
    return {
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: theme.palette.highlight.main, // Αλλάζει το χρώμα της γραμμής κάτω από το ενεργό tab
                },
            },
        },
        MuiTab: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    fontSize: '0.8125rem',
                    textTransform: 'uppercase',
                    fontWeight: 500,
                    lineHeight: '1.25rem',
                    color: theme.palette.primary[900],
                    '&.Mui-selected': {
                        color: theme.palette.highlight.main,
                        borderBottom: '1px solid',
                        borderColor: theme.palette.highlight.main,
                    },
                    
                    // minHeight: 46,
                    // color: theme.palette.text.primary,
                    // borderRadius: 4,
                    '&:hover': {
                        // backgroundColor: theme.palette.highlight.main,
                        color: theme.palette.highlight.main,
                    },
                    '&:focus-visible': {
                        // borderRadius: 4,
                        outline: `2px solid ${theme.palette.highlight.main}`,
                        outlineOffset: -3
                    }
                }
            }
        }
    }
}
